import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface AdminGuardProps {
  children: React.ReactNode;
}

/**
 * AdminGuard component
 * 
 * This component protects routes that should only be accessible to admin users.
 * It checks if the user is authenticated and has admin privileges.
 * If not, it redirects to the appropriate page.
 */
const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading, isAdmin } = useAuth();
  
  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Verifying authorization...</p>
      </div>
    );
  }
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // If not admin, redirect to home
  if (!isAdmin) {
    return <Navigate to="/home" replace />;
  }
  
  // If authenticated and admin, render children
  return <>{children}</>;
};

export default AdminGuard;